export default __webpack_public_path__ + "static/media/launch.bd07e532.mp4";